import React, { useImperativeHandle, useRef, useState } from "react";
import { DragSource, DropTarget } from "react-dnd";
import { CollapseArrow, CopyIcon, MoveIcon, TrashIcon } from "~/assets/svg/InterfaceIcon";
import { useTranslation } from "react-i18next";

const QuestionCard = React.forwardRef(
	(
		{
			question,
			idx,
			handleQuestionInputChange,
			handleQuestionCopyFields,
			handleQuestionRemoveFields,
			isDragging,
			connectDropTarget,
			connectDragPreview,
			connectDragSource,
		},
		ref
	) => {
		const { t } = useTranslation();
		const [openToggle, setOpenToggle] = useState(true);

		const targetRef = useRef(null);
		const sourceRef = useRef(null);
		connectDropTarget(targetRef);
		// connectDragPreview(targetRef);
		connectDragSource(sourceRef);

		useImperativeHandle(ref, () => ({
			getNode: () => targetRef.current,
		}));

		return (
			<>
				<li
					ref={targetRef}
					className={`c__card apply-card ${openToggle ? "" : "card-close"}`}
					data-ordernum={question.order}
					index={question.order}
				>
					<div className="apply-card-header" ref={sourceRef}>
						<button className="btn-inquiry-move">
							<MoveIcon />
						</button>
						<input
							className="c__input"
							placeholder={t("pages.applyFormMange.inputComponent.faq.questionTitle")}
							id={"questionTitle" + idx}
							name="Title"
							value={question.question || ""}
							onChange={(e) => handleQuestionInputChange(idx, e)}
						/>
						<button
							type="button"
							className="apply-toggle-btn"
							onClick={() => setOpenToggle(!openToggle)}
						>
							<CollapseArrow />
						</button>
					</div>
					<div className="apply-card-body">
						<textarea
							className="c__textarea"
							placeholder={t("pages.applyFormMange.inputComponent.faq.questionValue")}
							id={"questionValue" + idx}
							value={question.answer || ""}
							onChange={(e) => handleQuestionInputChange(idx, e)}
						/>
						<div className="inquiry-setting-bottom">
							<button
								type="button"
								className="btn-copy"
								onClick={() => handleQuestionCopyFields(idx)}
							>
								<CopyIcon />
							</button>
							<button
								type="button"
								className="btn-trash"
								onClick={(e) => handleQuestionRemoveFields(e, idx)}
							>
								<TrashIcon />
							</button>
						</div>
					</div>
				</li>
			</>
		);
	}
);

// export default QuestionCard;

export const ItemTypes = {
	CARD: "card",
};

export default DropTarget(
	ItemTypes.CARD,
	{
		hover(props, monitor, component) {
			if (!component) {
				return null;
			}

			const node = component.getNode();
			if (!node) {
				return null;
			}
			const dragIndex = monitor.getItem().index;
			const hoverIndex = props.index;

			if (dragIndex === hoverIndex) {
				return;
			}

			const hoverBoundingRect = node.getBoundingClientRect();
			const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
			const clientOffset = monitor.getClientOffset();
			const hoverClientY = clientOffset.y - hoverBoundingRect.top;

			if (
				(dragIndex < hoverIndex && hoverClientY > 0) ||
				(dragIndex > hoverIndex && hoverClientY > hoverMiddleY)
			) {
				return;
			}

			props.moveCard(dragIndex, hoverIndex);
			monitor.getItem().index = hoverIndex;
		},
	},
	(connect, monitor) => {
		return {
			connectDropTarget: connect.dropTarget(),
		};
	}
)(
	DragSource(
		ItemTypes.CARD,
		{
			beginDrag: (props, monitor, component) => {
				return { index: props.index };
			},
		},
		(connect, monitor) => {
			return {
				connectDragSource: connect.dragSource(),
				// connectDragPreview: connect.dragPreview(),
				isDragging: monitor.isDragging(),
			};
		}
	)(QuestionCard)
);
